import styled from 'styled-components'
import { mediaQ, fontSizeResponsive } from '../../../theme/mixins'
import addIngredientIcon from '../../../../assets/DietModuleAssets/addIcon.png'
import addItemIcon from '../../../../assets/REDESIGN_Assets/Diet/add-product-icon.svg'
import removeItemIcon from '../../../../assets/REDESIGN_Assets/Diet/remove-item-icon.svg'

export const MealsListContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const MealBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  position: relative;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 19px;
  padding: 3% 5%;
  box-sizing: border-box;
`

export const MealCalorieValue = styled.span`
  display: block;
  width: 53%;
  font-family: 'Nunito';
  ${fontSizeResponsive(16)};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.06;
  letter-spacing: normal;
  text-align: left;
  color: white;
  opacity: 0.88;

  @media only screen and (max-width: 600px) {
    ${fontSizeResponsive(20)};
  }
`
export const MealIngredientContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  cursor: pointer;
`

export const AddIngredientButton = styled.button`
  background: url(${addItemIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5vh;
  height: 1.5vh;
  border: none;
  position: absolute;
  right: 10px;
  top: calc(0px + 0.75vh);

  @media only screen and (max-width: 600px) {
    width: 2.5vh;
    height: 2.5vh;
    right: 5%;

    top: calc(0px + 2.5vh);
  }
`

export const RemoveMealButton = styled.button`
  background-color: transparent;
  width: 1.3vh;
  height: 1.3vh;
  border: none;
  position: absolute;
  background: url(${removeItemIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  right: 0px;

  @media only screen and (max-width: 600px) {
    width: 2.5vh;
    height: 2.5vh;
    right: 0;
  }

  top: 0vh;
  z-index: 2;
  transition: all 0.3s ease-in-out;
`

export const MealRow = styled.div`
  width: 100%;
  display: flex;

  justify-content: space-between;
  position: relative;
`
